export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "home": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Home"])},
        "search": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search"])},
        "people": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["People"])},
        "top": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Top 100"])},
        "wait": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Waitlist"])}
      }
    }
  })
}
